export const environment = {
  envName: 'IUAT',
  production: false,
  apiUrl: 'https://www.kawneer-ecommerce-dev.com/ipa/api',
  appId: 'KD',
  imageBaseUrl: 'https://www.kawneer-ecommerce-dev.com/ipa/',
  imageFolder: 'ResourceCenter/assets/itemCatalog/',
  imageUrl: 'https://www.kawneer-ecommerce-dev.com/ipa',
  thermalCalculatorUrl: 'https://www.kawneer-ecommerce-dev.com/tcu/thermal-calculator?ngsw-bypass=true',
  windowPricingToolUrl: 'https://www.kawneer-ecommerce-dev.com/wpt/ImportExportFile.aspx',
  maxCartQuoteItemCount: 99,
};
